module.exports = __webpack_public_path__ + "static/media/isNotFriendIcon.8bbff020.svg";